import {
  Button,
  Flex,
  Icon,
  InputItem,
  List,
  NavBar,
  Picker,
  SegmentedControl,
  Toast,
  WhiteSpace,
} from "antd-mobile";
import { useCallback, useEffect, useState } from "react";
import { bottomBtnStyle } from "..";
import instance from "../../../../util/axios";

interface oneProps {
  onCancel?: () => void;
  onOk?: (type: number, data: OrderInfo, userId: string, name: string) => void;
  defaultValues?: OrderInfo;
  defaultType?: number;
  customerId?: string;
}
export interface OrderInfo {
  orderType: string[];
  orderTypeName: string;
  customerName: string[];
  customer: string;
  customerType: string[];
  customerTypeName: string;
  contacts?: string;
  contactName?: string;
}

const orderType = [
  {
    value: "fef2a687f35c2936843e3ed03dfbc567",
    label: "新增",
  },
  {
    value: "fef2a687f35c2936843e3ed03dfbc568",
    label: "续费",
  },
];

const customerCategory = [
  {
    value: "78393aa0f9f646188766c864dd6499d0",
    label: "个人客户",
  },
  {
    value: "a70278f476b247ad8ab8e922a9e48c20",
    label: "企业客户",
  },
];

const StepOne = ({
  onCancel,
  onOk,
  defaultValues,
  defaultType,
  customerId,
}: oneProps) => {
  const [customerName, setCustomerName] = useState<
    {
      value: string;
      label: string;
    }[]
  >([]);

  const [sessionInfo, setSessionInfo] = useState<{
    userId: string;
    name: string;
  }>({ userId: "", name: "" });

  useEffect(() => {
    instance.get(`/crm/user/`).then((resp) => {
      setSessionInfo(resp.data.Data);
    });
  }, []);

  useEffect(() => {
    if (sessionInfo && sessionInfo.userId) {
      instance
        .post(`/wf/form/vsheet/rpc`, {
          method: "getMyCustomerId",
          workflowTemplateId: "ec4f846a6db74ec98395554a4c726a0f",
          paramsJson: JSON.stringify({ advisorId: sessionInfo.userId }),
        })
        .then((resp) => {
          if (resp.data.Status === "1") {
            setCustomerName(
              resp.data.Data.map((item: { id: any; text: any }) => ({
                value: item.id,
                label: item.text,
              }))
            );
          }
        });
    }
  }, [sessionInfo]);
  const [data, setData] = useState<OrderInfo>({
    orderType: ["fef2a687f35c2936843e3ed03dfbc567"],
    orderTypeName: "新增",
    customerName: [],
    customer: "",
    customerType: [],
    customerTypeName: "",
    contacts: "",
    contactName: "",
  });
  const [type, setType] = useState<number>(0);
  const [disabled, setDisabled] = useState<boolean>(false);

  useEffect(() => {
    if (defaultValues && JSON.stringify(defaultValues) !== "{}") {
      setData(defaultValues);
    }
    if (defaultType) {
      setType(defaultType);
    }
  }, [defaultValues, defaultType]);

  const getCustomerCategory = useCallback((customerId) => {
    instance
      .post(`/wf/form/vsheet/rpc`, {
        method: "getCategory",
        workflowTemplateId: "ec4f846a6db74ec98395554a4c726a0f",
        paramsJson: JSON.stringify({ customerId: customerId }),
      })
      .then((resp) => {
        if (resp.data.Status === "1") {
          setData((prevState) => ({
            ...prevState,
            customerType: [resp.data.Data],
            customerTypeName:
              resp.data.Data === "78393aa0f9f646188766c864dd6499d0"
                ? "个人客户"
                : "企业客户",
          }));
        }
      });
  }, []);

  const getContacts = useCallback((customerId) => {
    instance
      .post(`/wf/form/vsheet/rpc`, {
        method: "getMainContact",
        workflowTemplateId: "ec4f846a6db74ec98395554a4c726a0f",
        paramsJson: JSON.stringify({ customerId: customerId }),
      })
      .then((resp) => {
        if (resp.data.Status === "1" && resp.data.Data) {
          setData((prevState) => ({
            ...prevState,
            contacts: resp.data.Data.uuid,
            contactName: resp.data.Data.name,
          }));
        }
      });
  }, []);

  useEffect(() => {
    if (customerId && customerName.length > 0) {
      setDisabled(true);
      setData((prevState) => ({
        ...prevState,
        customerName: [customerId],
        customer: customerName.find((item) => item.value === customerId)!
          ?.label,
      }));

      getCustomerCategory(customerId);
      getContacts(customerId);
    }
  }, [customerId, customerName, getContacts, getCustomerCategory]);

  const onSave = useCallback(
    (type, data: OrderInfo) => {
      if (data.orderType.length === 0) {
        Toast.info("请选择订单类型", 1);
        return;
      } else if (data.customerName.length === 0) {
        Toast.info("请选择客户", 1);
        return;
      } else if (data.customerType.length === 0) {
        Toast.info("请选择客户类型", 1);
        return;
      }
      onOk?.(type, data, sessionInfo.userId, sessionInfo.name);
    },
    [onOk, sessionInfo.userId, sessionInfo.name]
  );

  return (
    <>
      <NavBar icon={<Icon type="left" onClick={onCancel} />}>
        销售及内训订单
      </NavBar>
      <WhiteSpace size="lg" />
      <div style={{ padding: "0 10px" }}>
        <SegmentedControl
          values={["产品订单", "内训订单"]}
          selectedIndex={type}
          onChange={(e) => {
            setType(e.nativeEvent.selectedSegmentIndex);
          }}
        />
      </div>
      <List
        style={{ backgroundColor: "white", marginTop: 15 }}
        className="picker-list">
        <Picker
          data={orderType}
          cols={1}
          disabled={true}
          itemStyle={{ color: "#888" }}
          indicatorStyle={{ color: "#888" }}
          value={data.orderType}
          onChange={(val: any) => {
            setData({
              ...data,
              orderType: val!,
              orderTypeName: orderType.find((item) => item.value === val[0])!
                ?.label,
            });
          }}>
          <List.Item arrow="horizontal">
            <span style={{ color: "red", marginRight: 5 }}>*</span>
            <span className="disabledPicker">订单类型</span>
          </List.Item>
        </Picker>
        <Picker
          data={customerName}
          cols={1}
          value={data.customerName}
          disabled={disabled}
          onChange={(val: any) => {
            setData({
              ...data,
              customerName: val!,
              customer: customerName.find((item) => item.value === val[0])!
                ?.label,
            });
            getCustomerCategory(val[0]);
            getContacts(val[0]);
          }}>
          <List.Item arrow="horizontal">
            <span style={{ color: "red", marginRight: 5 }}>*</span>
            <span className={disabled ? "disabledPicker" : ""}>客户名称</span>
          </List.Item>
        </Picker>
        <Picker
          data={customerCategory}
          cols={1}
          value={data.customerType}
          disabled>
          <List.Item arrow="horizontal">
            <span style={{ color: "red", marginRight: 5 }}>*</span>
            <span className="disabledPicker">客户类型</span>
          </List.Item>
        </Picker>
        <InputItem disabled={true} value={data.contactName}>
          联系人
        </InputItem>
      </List>
      <Flex style={bottomBtnStyle}>
        <Flex.Item>
          <Button type="primary" onClick={onCancel}>
            取消
          </Button>
        </Flex.Item>
        <Flex.Item>
          <Button type="primary" onClick={() => onSave?.(type, data)}>
            创建订单
          </Button>
        </Flex.Item>
      </Flex>
    </>
  );
};

export default StepOne;
